export default "__VITE_ASSET__DKAIm3Be__"